import { Checkbox } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const StyledCheckbox = styled(Checkbox, {})({
  color: theme.palette.placeholdergrey,

  '&.Mui-checked': {
    color: theme.palette.placeholdergrey,
  },
});
